import { Popup, PopupProps } from '@innovyze/inno-map';
import React, { useState } from 'react';
import { PopupDetails } from './PopupDetails';
import { Feature } from './types';
import { assetSchemaSelectorByType } from '@innovyze/lib_asset_schema_store';
import { useSelector } from 'react-redux';

export const AssetPopup = (
	props: Omit<PopupProps<Feature[]>, 'children'>,
): JSX.Element => {
	const [assetType, setAssetType] = useState('wwManhole');
	const assetSchema = useSelector(state =>
		assetSchemaSelectorByType(state, assetType),
	);

	const popupWidth = assetSchema?.hasCapability('Inspections') ? 450 : 400;

	const setTypeOfAsset = (aType: string) => {
		setAssetType(aType);
	};

	return (
		<Popup {...props} width={popupWidth}>
			{features => {
				// filter out non-assets
				const feature = features.find(({ id }) => id.match('#'));
				if (!feature) return null;
				const [aType] = feature.id.split('#');
				setTypeOfAsset(aType);
				return <PopupDetails feature={feature} />;
			}}
		</Popup>
	);
};
